import { createContext } from 'react';
import type { TDependentsContextValue } from './Dependents.types.ts';

export const DependentsContext = createContext<
  TDependentsContextValue | undefined
>(undefined);
